// Copyright (c) Docugami, Inc. All rights reserved.

export enum NavigationGroup {
    Projects = 'Projects',
    DocSets = 'DocSets',
    Discovery = 'Discovery',
    ReviewDocs = 'ReviewDocs',
    DocSources = 'DocSources'
}

export enum ReviewDocsId {
    Unassigned = 'Unassigned',
    Error = 'Error'
}

export enum DocSourceId {
    All = "All",
    Local = "Local",
    SharePoint = "SharePoint",
    OneDrive = "OneDrive",
    Box = 'Box',
    Dropbox = 'Dropbox'
}

export enum ExplorerViewType {
    DocSources = 'DocSources',
    LocalDocSource = 'LocalDocSource',
    RemoteDocSource = 'RemoteDocSource',
    Projects = 'Projects',
    DocSet = 'DocSet',
    Discovery = 'Discovery',
    Unassigned = 'Unassigned',
}